<template>
  <div class="company-info-details">
    <MoreTitle title="公司资料" />
    <div class="row-wrapper edge-padding">
      <RowInfo label="公司名称">{{ $digitjs(name).isNull() }}</RowInfo>
      <RowInfo label="ISIN">
        <template v-slot:label>
          <span @click="isPopup = true">ISIN<i class="iconfont icon-tishishuoming"></i></span>
        </template>
        {{ $digitjs(comInfo.isin).isNull() }}
      </RowInfo>
      <RowInfo label="上市日期">{{ $digitjs(comInfo.listDate).isNull() }}</RowInfo>
      <RowInfo label="主席">{{ $digitjs(comInfo.chairman).isNull() }}</RowInfo>
      <RowInfo label="公司秘书">{{ $digitjs(comInfo.companySecretary).isNull() }}</RowInfo>
      <RowInfo label="注册地">{{ $digitjs(comInfo.regAddress).isNull() }}</RowInfo>
      <RowInfo label="办公地址">{{ $digitjs(comInfo.comAddress).isNull() }}</RowInfo>
      <RowInfo v-if="market !== 'hs'" label="员工人数">{{ $digitjs(comInfo.numberOfEmployees).isNull() }}</RowInfo>
      <RowInfo v-if="market === 'hk'" label="审计机构">{{ $digitjs(comInfo.auditors).isNull() }}</RowInfo>
      <RowInfo label="会计年结日">{{
        comInfo.periodEndDate ? $dayjs(comInfo.periodEndDate).format('MM-DD') : '--'
      }}</RowInfo>
      <RowInfo label="所属市场">{{ $digitjs(comInfo.mainExchange ?? comInfo.market).isNull() }}</RowInfo>
      <RowInfo label="公司邮箱">{{ $digitjs(comInfo.email).isNull() }}</RowInfo>
      <RowInfo label="公司官网">{{ $digitjs(comInfo.website).isNull() }}</RowInfo>
      <RowInfo label="公司简介" column><EllipsisText :text="comInfo.comProfile" :rows="16" /></RowInfo>
      <RowInfo label="主营业务" column>{{ comInfo.comBusiness }}</RowInfo>
    </div>
    <Popup :visible.sync="isPopup">ISIN指国际证券识别码，由12位字母数字组成的独一无二的编码。</Popup>
  </div>
</template>

<script>
import RowInfo from '@/components/common/RowInfo.vue'
import EllipsisText from '@/components/common/EllipsisText'
import { sendMsg } from "@/plugins/msg";
export default {
  components: { RowInfo, EllipsisText },
  data() {
    return {
      isPopup: false,
      comInfo: {}
    }
  },
  computed: {
    lang() {
      return this.$i18n.lang
    },
    name() {
      const nameMap = {
        'zh-cn': this.comInfo?.name ?? this.comInfo?.cnName ?? this.comInfo?.cnComName,
        'zh-hk': this.comInfo?.name ?? this.comInfo?.cnName ?? this.comInfo?.cnComName,
        'en-us':
          this.comInfo?.name ??
          this.comInfo?.enName ??
          this.comInfo?.enComName ??
          this.comInfo?.cnName ??
          this.comInfo?.cnComName
      }
      return nameMap[this.lang] ?? nameMap['zh-cn']
    },
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    }
  },
  created() {
    this.getComInfo()
    sendMsg({ event: 'setTitle', title: '公司资料' })
  },
  methods: {
    async getComInfo() {
      const res = await this.$post(this.$api.f10[this.market] + '/summary/com-info', {
        symbol: this.symbol
      })
      this.comInfo = res?.data?.[0] ?? {}
    }
  }
}
</script>

<style lang="scss" scoped>
.company-info-details {
  background: var(--bg-color-2);
  .iconfont {
    font-size: 13px;
    margin-left: 4px;
  }
}
</style>
